import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ContentComponent } from './content.component';
import { GiantSharedModule } from '../../shared/GiantSharedModule';



@NgModule({
    declarations: [
        ContentComponent
    ],
    imports     : [
        RouterModule,
        GiantSharedModule
    ],
    exports     : [
        ContentComponent
    ]
})
export class ContentModule
{
}
